/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q7Inputs */

const et_faq_q7 = /** @type {(inputs: Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuidas AI ja automaatika aitavad ettevõtte müüki kasvatada?`)
};

const en_faq_q7 = /** @type {(inputs: Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do AI and automation help grow sales?`)
};

/**
* | output |
* | --- |
* | "How do AI and automation help grow sales?" |
*
* @param {Faq_Q7Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_q7 = /** @type {((inputs?: Faq_Q7Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q7Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_q7(inputs)
	return en_faq_q7(inputs)
});